const COUNTRY_FILTER_OPTIONS = {
    Country_All: null,
    Country_UnitedStates: "US",
    Country_UnitedKingdom: "UK",
    Country_EuropeanMonetaryUnion: "EMU",
    Country_Germany: "DE",
    Country_China: "CN",
    Country_Japan: "JP",
    Country_Canada: "CA",
    Country_Australia: "AU",
    Country_NewZealand: "NZ",

    Country_Switzerland: "CH",
    Country_France: "FR",
    Country_Italy: "IT",
    Country_Spain: "ES",

    Country_Ukraine: "UA",

    Country_India: "IN",
    Country_Russia: "RU",
    Country_Turkey: "TR",
    Country_SouthAfrica: "ZA",
    Country_Brazil: "BR",
    Country_SouthKorea: "KR",
    Country_Indonesia: "ID",
    Country_Singapore: "SG",
    Country_Mexico: "MX",
    Country_Sweden: "SE",
    Country_Norway: "NO",
    Country_Denmark: "DK",
    Country_Greece: "GR",
    Country_Portugal: "PT",
    Country_Ireland: "IE",
    Country_Austria: "AT",
    Country_Belgium: "BE",
    Country_Netherlands: "NL",
    Country_Finland: "FI",
    Country_CzechRepublic: "CZ",
    Country_Poland: "PL",
    Country_Hungary: "HU",
    Country_Romania: "RO",
    Country_Chile: "CL",
    Country_Colombia: "CO",
    Country_Argentina: "AR",
    Country_Iceland: "IS",
    Country_HongKong: "HK",
    Country_Slovakia: "SK",
    Country_Israel: "IL",
    Country_SaudiArabia: "SA",
    Country_Vietnam: "VN",
    Country_Kuwait: "KW",
    Country_Egypt: "EG",
    Country_UnitedArabEmirates: "AE",
    Country_Qatar: "QA",
    Country_Thailand: "TH",
};

const getBasicCountries = (countries) => {
    if (!countries) return null;

    return countries.slice(0, 9);
};

const getMajorCountries = (countries) => {
    if (!countries) return null;

    return countries.slice(0, 14);
};

const getMinorCountries = (countries) => {
    if (!countries) return null;

    return countries.slice(14);
};

const getCountryNameByCountryCode = (code) => {

    return Object.keys(COUNTRY_FILTER_OPTIONS).find(key => COUNTRY_FILTER_OPTIONS[key] === code);
}

export {
    COUNTRY_FILTER_OPTIONS,
    getBasicCountries,
    getMajorCountries,
    getMinorCountries,
    getCountryNameByCountryCode,
};
